<template>
  <input type="file" name="fileUpload" @change="onFileChange">
</template>

<script type="text/javascript">

export default {
  name: 'FileUpload',
  props: {
    target: {
      type: String
    },
    action: {
      type: String,
      default: 'POST'
    }
  },
  data () {
    return {
      file: null
    }
  },
  methods: {
    emitter (event, data) {
      this.$emit(event, data)
    },
    uploadProgress (oEvent) {
      let vm = this
      if (oEvent.lengthComputable) {
        let percentComplete = Math.round(oEvent.loaded * 100 / oEvent.total)
        vm.emitter('progress', percentComplete)
      } else {
        // Unable to compute progress information since the total size is unknown
        vm.emitter('progress', false)
      }
    },
    fixImageOrientation(file) {

     return new Promise((resolve) => {

       if ('type' in file && file.type && file.type.startsWith('image/')) {

         try {
           const reader = new FileReader()
           reader.readAsDataURL(file)

           reader.onloadend = function(e) {

             let img = new Image()
             img.src = e.target.result

             img.onload = function() {

              console.log("img.onload")

               let width = img.width
               let height = img.height
               let canvas = document.createElement('canvas')
               let ctx = canvas.getContext('2d');

               canvas.width = width
               canvas.height = height
               ctx.drawImage(img, 0, 0)

               canvas.toBlob(blob => {
                 const newFile = new File([blob], file.name, file);

                 console.log("newFile",newFile)

                 resolve(newFile)
               }, file.type)
             }
           }
         } catch (e) {
           console.log('Invalid File: ', e)
         }
       } else {
          console.log("doesn't start with image")
         resolve(file)
       }
     })
   },
    onFileChange (e) {
      let vm = this

      if (!this.target || this.target === '') {
        console.log('Please provide the target url')
      } else if (!this.action || this.action === '') {
        console.log('Please provide file upload action ( POST / PUT )')
      } else if (this.action !== 'POST' && this.action !== 'PUT') {
        console.log('File upload component only allows POST and PUT Actions')
      } else {
        let files = e.target.files || e.dataTransfer.files

        if (!files.length) {
          return
        };

        /*global FormData XMLHttpRequest:true*/
        /*eslint no-undef: "error"*/

      Array.from(files).forEach((file, index) => {

        if (file.type != "image/heic") {
          this.fixImageOrientation(file).then((fixedFile) => {

            let formData = new FormData()
            formData.append('file', fixedFile)

            var xhr = new XMLHttpRequest()
            xhr.open(this.action, this.target)

            xhr.onloadstart = function (e) {
              vm.emitter('start', e)
            }
            xhr.onloadend = function (e) {
              vm.emitter('finish', e)
            }
            xhr.upload.onprogress = vm.uploadProgress

            xhr.send(formData)
          })
        }
        else {
          let formData = new FormData()
            formData.append('file', file)

            var xhr = new XMLHttpRequest()
            xhr.open(this.action, this.target)

            xhr.onloadstart = function (e) {
              vm.emitter('start', e)
            }
            xhr.onloadend = function (e) {
              vm.emitter('finish', e)
            }
            xhr.upload.onprogress = vm.uploadProgress

            xhr.send(formData)
        }
      })
      }
    }
  }
}
</script>